export default __webpack_public_path__ + "static/media/student-photo.a5a5ed5a.svg";